import React from 'react';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { ArrowPathIcon as Refresh } from '@heroicons/react/20/solid';
import tw from 'twin.macro';
import { useRouteError } from 'react-router-dom';
import { NotFoundPage } from '@teetsh/app/src/components/ErrorPage/NotFoundPage';
import { TooManyRequestsPage } from '@teetsh/app/src/components/ErrorPage/TooManyRequestsPage';
import { useTranslation } from 'react-i18next';
import * as Sentry from '@sentry/react';

interface Props {
  center?: boolean;
}

export function ErrorPage(props: Props) {
  const { center = true } = props;
  const { t } = useTranslation(['common']);
  const error = useRouteError() as any;
  if (error?.status === 404) {
    return <NotFoundPage />;
  }
  if (error?.status === 429) {
    return <TooManyRequestsPage />;
  }
  Sentry.captureException(error);
  return (
    <div
      css={[
        center && tw`items-center h-full`,
        tw`flex flex-wrap pt-6 justify-center `,
      ]}
    >
      <div tw="text-center p-10">
        <div tw="mb-6">
          <div tw="font-extrabold text-center sm:text-5xl text-4xl">
            {t('common:errorPage.oups')}
          </div>
        </div>
        <div tw="text-xl text-muted">
          {t('common:errorPage.thereWasAProblem')}
          <div tw="pt-8">
            <i>{(error as any)?.statusText || (error as any)?.message}</i>
          </div>
        </div>
        <br />
        <Button
          onClick={() => window.location.reload()}
          minimal
          large
          intent="primary"
          icon={Refresh}
        >
          {t('common:buttons.reloadPage')}
        </Button>
        <br />
        <br />

        <div>
          {t('common:errorPage.contactUsIfPersisting')}
          <br />
          <a href="mailto:hello@teetsh.com">hello@teetsh.com</a> <br />
          {t('common:errorPage.orUsingTheChat')}
        </div>
      </div>
    </div>
  );
}
